import React, { useState } from 'react';
import { Divider, Grid } from '@mui/material';
import { Button } from '@mui/material';
import { useDashboardContext } from 'context/dashboard.context';
import TuneIcon from '@mui/icons-material/Tune';
import CustomIcon from '../Icon/CustomIcon';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import theme from 'theme';

interface FiltersProps {
  onApplyFilters: () => void;
  onClearFilters: () => void;
  filterInputs: JSX.Element[];
  hasFilters?: boolean;
}

const Filters = ({
  filterInputs,
  onClearFilters,
  onApplyFilters,
  hasFilters = true,
}: FiltersProps) => {
  const { md } = useDashboardContext();
  const [show, setShow] = useState(md);

  return (
    <>
      <Grid container spacing={2}>
        {show && (
          <>
            {filterInputs.map((input, i) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={i}>
                {input}
              </Grid>
            ))}
            <Grid item xs={12} display='flex' alignItems='center' justifyContent='flex-end'>
              <CustomIcon
                icon={<RestartAltIcon />}
                label='Reset Filters'
                onClick={() => onClearFilters()}
                margin='0 1rem 0 1rem'
              />
              <Button onClick={() => onApplyFilters()}>Apply Filters</Button>
            </Grid>
          </>
        )}
      </Grid>
      <Divider variant={'fullWidth'} sx={{ margin: '2rem 0' }} />
    </>
  );
};

export default Filters;
